import styled from "styled-components";

import { media } from "../styles/media";

export const ServiceRequestsStyles = styled.section`
  min-height: calc(100vh - 42px);

  .tableCard {
    margin-top: ${({ theme }) => theme.spacing[24]};
    overflow: hidden;

    .tableHead {
      display: flex;
      align-items: center;
      background: ${({ theme }) => theme.colors.semantic.container.gray};
      border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
      padding: ${({ theme }) => theme.spacing[12]} ${({ theme }) => theme.spacing[24]};

      .tableHeadTitle {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.1px;
        color: ${({ theme }) => theme.colors.semantic.text.weak};
      }
    }

    .serviceRow {
      transition: background 0.2s ease;
      user-select: none;

      &:hover {
        background: ${({ theme }) => theme.colors.accent[50]};
      }
    }

    /* Below the tablet breakpoint the 6-column table scrolls horizontally as a
       unit (header + rows share the same min-width) instead of crushing the
       columns into unreadable widths. */
    .tableScroll {
      ${media.maxTablet`
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        .tableHead,
        .serviceRow {
          min-width: 760px;
        }
      `}
    }
  }

  .ID {
    /* width: 15%; */
    width: 12.6%;
  }

  .user {
    /* width: 20%; */
    width: 12.6%;
    text-align: center;
  }

  .serviceType {
    /* width: 15%; */
    width: 16.6%;
    text-align: center;
  }

  .bookedFor {
    /* width: 20%; */
    width: 18.6%;
    text-align: center;
  }

  .messages {
    /* width: 12%; */
    width: 18.6%;
    text-align: center;
  }

  .actions {
    /* width: 18%; */
    width: 19.6%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .newRequestsContainer {
    margin-top: 14px;

    .newRequestsLabel {
      padding: 2px 6px;
      border-radius: 3px 3px 3px 0px;
      background: ${({ theme }) => theme.colors.semantic.container.gray};
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      width: 94px;
    }
  }


  .estimationCard {
    height: unset;
  }
`;
